import { useTranslation } from "react-i18next"
import { HeaderSectionWrapper } from "./styles"
import CustomButton from "@Common/CustomButton"
import { useState } from "react"
import UserManagementCentre from "../userManagementCentre"

export default function HeaderSection() {
	const [isUserManagementCentreOpen, setIsUserManagementCentreOpen] =
		useState(false)
	const { t } = useTranslation()
	return (
		<HeaderSectionWrapper>
			{isUserManagementCentreOpen && (
				<UserManagementCentre
					onclose={() => setIsUserManagementCentreOpen(false)}
				/>
			)}
			<div className="sectionHeader">
				<p>{t("UserManagement.UserManagement")}</p>
				<p>{t("UserManagement.a_space_to_look_at_manage_your_guests")}</p>
			</div>
			<div>
				<CustomButton
					withBG
					label={t("UserManagement.add_a_service_provider_team_member")}
					borderRadius='12px'
					customPadding='12px 24px'
					type='button'
					onClick={() => setIsUserManagementCentreOpen(true)}
				/>
			</div>
		</HeaderSectionWrapper>
	)
}
